import {useContext} from "react";
import {StoreContext} from "../stores/StoreLoader";
import ClickableLink from "../components/utilities/ClickableLink";

export default function ErrorPage(): JSX.Element {
    const {organizationStore} = useContext(StoreContext);

    return <div id="sb-main-content" className="sb-error-container sb-content-width" style={{maxWidth: "600px", paddingTop: "100px"}}>
        <div className="sb-error-block">
            <div className="sb-error-message">
                <h3 className="text-danger"><b>Sorry, but you've reached a page that does not exist.</b></h3>
                <p>
                    Most likely this happened because you tried to access a page from the old website. Welcome to
                    the new website! Follow any of the links above to navigate through the new website.
                </p>
                {organizationStore?.organization &&
                    <ClickableLink className={"btn sb-organization-color-element-bg"}
                                   title="Go to the homepage"
                                   href={organizationStore.organization?.json_data?.settings?.appearance?.showWelcomePage ? "/?showHomepage=true" : "/"}
                >Go Home</ClickableLink>}
            </div>
        </div>
    </div>
}
